import { useRef } from 'react';
import { RigidBody, RapierRigidBody } from '@react-three/rapier';
import { Box } from '@react-three/drei';
import Card from '../components/Card';

export default function TableScene() {
  // Create a reference to interact with the table physics body
  const tableRef = useRef<RapierRigidBody>(null);

  // Basic game setup with a table and some cards
  return (
    <>
      {/* Table surface */}
      <RigidBody type="fixed" ref={tableRef} colliders="cuboid" >
        <Box args={[20, 1, 20]} receiveShadow>
          <meshStandardMaterial color="#076324" roughness={0.8} metalness={0.2} />
        </Box>
      </RigidBody>

      {/* Add some playing cards to the scene */}
      <Card id="testing"/>
      
      {/* Add a deck of cards */}
      <DeckOfCards position={[3, 0.5, 0] as [number, number, number]} />
    </>
  );
}

// Component for a deck of cards
function DeckOfCards({ position = [0, 0, 0] as [number, number, number] }) {
  // Create a reference to interact with the deck physics body
  const deckRef = useRef<RapierRigidBody>(null);
  
  // Apply a small random force to the deck when clicked to simulate dealing
  const dealCard = () => {
    if (deckRef.current) {
      const force = {
        x: (Math.random() - 0.5) * 3,
        y: 2,
        z: (Math.random() - 0.5) * 3
      };
      deckRef.current.applyImpulse(force, true);
    }
  };
  
  return (
    <RigidBody ref={deckRef} position={position} colliders="cuboid">
      <Box args={[2.5, 1, 3.5]} onClick={dealCard}>
        <meshStandardMaterial color="#2a2a2a" />
      </Box>
    </RigidBody>
  );
}